
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Schema.org JSON-LD構造化データを追加
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "39raリフォーム有限会社 サクラリフォーム",
      "alternateName": "壁紙革命浦和",
      "description": "埼玉県さいたま市の賃貸物件向け壁紙リメイクサービス。壁紙張替え・クロス交換不要、約半額のコストで2-3時間の短時間施工。",
      "url": siteUrl,
      "telephone": "048-614-1544",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "3-13-15",
        "addressLocality": "さいたま市浦和区",
        "addressRegion": "埼玉県",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 35.8617,
        "longitude": 139.6503
      },
      "openingHours": [
        "Mo-Sa 09:00-18:00"
      ],
      "serviceArea": {
        "@type": "Place",
        "name": "埼玉県全域、東京都内の一部地域"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "壁紙リメイクサービス",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "クロスメイク（壁紙再生）",
              "description": "壁紙を張り替えずに新品同様に再生する特許工法"
            }
          }
        ]
      },
      "priceRange": "¥25,000-¥45,000"
    };

    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "クロスメイク（壁紙再生サービス）",
      "description": "賃貸物件の原状回復を約半額のコストで、わずか2-3時間で完了。壁紙を張り替えずに新品同様の仕上がりを実現します。",
      "provider": {
        "@type": "LocalBusiness",
        "name": "39raリフォーム有限会社 サクラリフト",
        "telephone": "048-614-1544"
      },
      "areaServed": {
        "@type": "Place",
        "name": "埼玉県全域、東京都内の一部地域"
      },
      "offers": {
        "@type": "Offer",
        "priceRange": "¥25,000-¥45,000",
        "priceCurrency": "JPY"
      }
    };

    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "壁紙革命浦和",
      "url": siteUrl,
      "description": "埼玉県さいたま市の賃貸物件向け壁紙リメイクサービス",
      "publisher": {
        "@type": "Organization",
        "name": "39raリフォーム有限会社 サクラリフト"
      }
    };

    // 既存のスクリプトタグを削除
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
    existingScripts.forEach(script => script.remove());

    // 新しいスキーマを追加
    const schemas = [localBusinessSchema, serviceSchema, websiteSchema];
    schemas.forEach(schema => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      // クリーンアップ
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => script.remove());
    };
  }, []);

  const beforeAfterImages = [
    {
      category: '換気扇・換気口',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/0c0b3690a7315279fb66c272f710923b.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/40b7e1838f92ad4641fc8ac9573f91a8.jfif',
      description: '調理油やホコリで黄ばみや黒ずみが見える換気扇周りも、クロスメイクなら短時間で真っ白に。'
    },
    {
      category: '冷蔵庫裏',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/1caa93d67b3fbdf59b84cc83ac34f3e5.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/7d82143fe9c0beb9e038ea68b2e98957.jfif',
      description: '家具を動かさなくても、冷蔵庫裏のシミ・黒ずみをきれいにリメイクできます。'
    },
    {
      category: 'ヤニ汚れ',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/b73da1dfaaf3884917b520b664ddb1c6.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/32dbd8c94356c3b6fe38f58b02ba28dc.jfif',
      description: 'タバコのヤニで変色した壁紙も、臭いを残さずホワイト再生。'
    },
    {
      category: 'カビ汚れ',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/7f682debfceb0eeee340d1f2d53d7700.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/e988cfed0a06c95d389add44e7c4f709.jfif',
      description: '湿気によるカビ汚れも、クロスメイクで完全に除去し、抗菌・防カビ効果で清潔な状態を保ちます。'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % beforeAfterImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + beforeAfterImages.length) % beforeAfterImages.length);
  };

  const handleEstimateClick = () => {
    const estimateSection = document.getElementById('estimate-form');
    if (estimateSection) {
      estimateSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleCaseStudyClick = () => {
    const caseSection = document.getElementById('case-studies');
    if (caseSection) {
      caseSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="bg-white shadow-sm border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="text-2xl font-bold text-teal-600" style={{ fontFamily: 'Pacifico, serif' }}>
                クロスメイク浦和
              </div>
              <div className="text-lg font-bold text-navy-800 bg-teal-50 px-4 py-2 rounded-lg">
                オーナー様の味方
              </div>
            </div>
            <nav className="hidden md:flex space-x-6">
              <a href="#service" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                サービス内容
              </a>
              <Link to="/before-after" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                施工事例
              </Link>
              <a href="#pricing" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                料金
              </a>
              <a href="#faq" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                よくある質問
              </a>
              <a href="#company" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                会社概要
              </a>
            </nav>
            <div className="flex items-center space-x-4">
              <a href="https://lin.ee/g0Jj95Y" target="_blank" rel="noopener noreferrer">
                <img 
                  src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png" 
                  alt="友だち追加" 
                  height="36" 
                  className="cursor-pointer hover:opacity-80 transition-opacity"
                />
              </a>
              <div className="text-sm text-gray-600">TEL: 048-614-1544</div>
            </div>
          </div>
        </div>
      </header>

      {/* ヒーローセクション */}
      <section
        className="relative bg-cover bg-center py-20 min-h-screen flex items-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/1d94868b954778f0003f7a94f2efb842.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-black/20">
          <div className="absolute bottom-8 right-8">
            <span className="bg-orange-500 text-white text-4xl font-bold px-6 py-3 rounded-lg">
              外壁塗装専門店＋特許工法
            </span>
          </div>
        </div>
        <div className="container mx-auto px-4 relative z-10 w-full">
          <div className="max-w-4xl">
            <div className="mb-6">
              <span className="inline-block bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-3 rounded-full text-xl font-bold shadow-lg transform -rotate-2">
                賃貸オーナーに朗報！
              </span>
            </div>
            <h1
              className="text-6xl md:text-8xl font-black text-orange-500 mb-8 leading-tight drop-shadow-2xl"
              style={{
                fontFamily: 'Impact, "Arial Black", sans-serif',
                textShadow: '3px 3px 6px rgba(255,255,255,0.5), 0 0 20px rgba(255,255,255,0.3)'
              }}
            >
              クロス交換は<br />
              しなくてよくなりました！
            </h1>
            <p className="text-xl md:text-2xl text-white mb-8 font-semibold bg-black/20 inline-block px-6 py-3 rounded-lg">
              物件の入退去の際は、管理会社任せではなくオーナー発注をお勧めします
            </p>
            <p className="text-lg text-white mb-12 bg-black/20 inline-block px-6 py-4 rounded-lg">
              賃貸物件の原状回復を約半額のコストで、わずか2-3時間で完了。<br />
              壁紙を張り替えずに新品同様の仕上がりを実現します。
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={handleEstimateClick}
                className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap shadow-lg transform hover:scale-105"
              >
                メールで無料見積り
              </button>
              <button
                onClick={handleCaseStudyClick}
                className="bg-white hover:bg-gray-50 text-gray-800 px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap border border-gray-200 shadow-lg transform hover:scale-105"
              >
                施工事例を見て判断する
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* サービス概要 */}
      <section id="service" className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">クロスメイクとは</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              もとの壁紙のままの凹凸を残し、オリジナル染色剤を塗布し、元々の色に再生する工法です。<br />
              下地に染み込まず剥がせなくなることがなく、穴や傷を補修した後に施工するため新品同様の仕上がりになります。
            </p>
          </div>

          {/* 楽待新聞のコラム紹介セクション */}
          <div className="mb-16">
            <div className="bg-white p-12 rounded-xl shadow-lg max-w-6xl mx-auto">
              <div className="flex items-center mb-8">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mr-6">
                  <i className="ri-newspaper-line text-3xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-gray-800 mb-2">楽待新聞で紹介されました</h3>
                  <p className="text-lg text-gray-600">
                    不動産投資専門メディア「楽待新聞」でクロスメイクが特集されました
                  </p>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-8 mb-10">
                <div>
                  <img
                    src="https://www.rakumachi.jp/news/wp-content/uploads/2017/10/Fotolia_103230139_S.jpg"
                    alt="楽待新聞のクロスメイク記事"
                    className="w-full h-64 object-cover rounded-lg shadow-md"
                  />
                </div>
                <div className="space-y-6">
                  <h4 className="text-2xl font-bold text-gray-800">
                    「壁紙が新品同様に復活する魔法『クロスメイク』」
                  </h4>
                  <div className="space-y-4 text-gray-600">
                    <div className="flex items-start space-x-3">
                      <i className="ri-check-line text-teal-600 mt-1 text-lg"></i>
                      <span className="text-base">
                        「傷んだ壁紙は張り替えるしかない」という常識を覆す方法として紹介
                      </span>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-check-line text-teal-600 mt-1 text-lg"></i>
                      <span className="text-base">
                        古い壁紙を張り替えずに専用染色剤で新品同様に蘇らせる独自工法
                      </span>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-check-line text-teal-600 mt-1 text-lg"></i>
                      <span className="text-base">施工時間短縮と約半額のコストを実現</span>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-check-line text-teal-600 mt-1 text-lg"></i>
                      <span className="text-base">
                        抗菌・消臭効果もあり、環境にも優しい工法
                      </span>
                    </div>
                  </div>
                  <a
                    href="https://www.rakumachi.jp/news/column/213091"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold cursor-pointer text-lg"
                  >
                    記事を読む <i className="ri-external-link-line ml-2 text-lg"></i>
                  </a>
                </div>
              </div>

              {/* クロスメイク施工サンプル画像 */}
              <div className="bg-gray-50 p-8 rounded-xl mb-10">
                <h4 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                  クロスメイク施工サンプル
                </h4>
                <div className="flex justify-center">
                  <img
                    src="https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/4a0a1df0273cfc1090124e0f4af482df.jfif"
                    alt="クロスメイク施工サンプル - 施工前後の比較"
                    className="max-w-full h-auto rounded-lg shadow-md"
                  />
                </div>
                <p className="text-center text-gray-600 mt-4 text-lg">
                  実際の施工サンプル：下部分が施工前、上部分が施工後の状態です。<br />
                  リペアも同時に行うため、傷や穴も完全に修復されます。
                </p>
              </div>

              <div className="mt-10 p-8 bg-teal-50 rounded-xl">
                <div className="flex items-start space-x-6">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-quote-text text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-gray-700 italic text-lg leading-relaxed">
                      「壁の隅や窓との境目から当社開発のコート剤・クロスメイクを塗っていき、専用のロングハケでなじませれば完了。技術、道具いずれも特許取得済みです。キットさえあれば誰でも、ムラなく塗ることができ、荷物も少なく、スタッフの中には電車で依頼主のところに向かう人も。養生する必要もなく、準備0分、片づけ0分のスピード感でできます」
                    </p>
                    <p className="text-base text-gray-500 mt-3">
                      - 株式会社 壁紙革命 代表 萩原利男氏
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">約半額のコスト</h3>
              <p className="text-gray-600">
                張替えの約半額の費用で原状回復でき、オーナーの費用負担を大幅に軽減します。
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">短時間施工</h3>
              <p className="text-gray-600">
                施工時間は2〜3時間と張替えの1/3で終了するため、空室期間を短縮できます。
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-leaf-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">環境配慮</h3>
              <p className="text-gray-600">
                古クロスの廃棄がほとんど発生せず、後の片付けの手間が少なく環境にも優しい工法です。
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">安全・無臭</h3>
              <p className="text-gray-600">
                ホルムアルデヒドを含まない水性塗料で安全。施工後は無臭になり、すぐに内覧可能です。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 施工事例セクション */}
      <section id="case-studies" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">施工事例</h2>
            <p className="text-lg text-gray-600">
              汚れ別のビフォーアフター写真で、クロスメイクの効果をご確認ください
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="relative bg-gray-100 rounded-lg overflow-hidden">
              <div className="p-8">
                <h3 className="text-2xl font-bold text-center text-gray-800 mb-8">
                  {beforeAfterImages[currentSlide].category}
                </h3>

                <div className="grid md:grid-cols-2 gap-8">
                  <div className="text-center">
                    <h4 className="text-lg font-semibold text-gray-700 mb-4">施工前</h4>
                    <img
                      src={beforeAfterImages[currentSlide].before}
                      alt={`${beforeAfterImages[currentSlide].category}の汚れ_before`}
                      className="w-full h-64 object-cover rounded-lg shadow-md"
                    />
                  </div>
                  <div className="text-center">
                    <h4 className="text-lg font-semibold text-gray-700 mb-4">施工後</h4>
                    <img
                      src={beforeAfterImages[currentSlide].after}
                      alt={`${beforeAfterImages[currentSlide].category}_after`}
                      className="w-full h-64 object-cover rounded-lg shadow-md"
                    />
                  </div>
                </div>

                <p className="text-center text-gray-600 mt-6">
                  {beforeAfterImages[currentSlide].description}
                </p>
              </div>

              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white p-3 rounded-full shadow-md cursor-pointer transition-colors"
              >
                <i className="ri-arrow-left-line text-xl text-gray-700"></i>
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white p-3 rounded-full shadow-md cursor-pointer transition-colors"
              >
                <i className="ri-arrow-right-line text-xl text-gray-700"></i>
              </button>
            </div>

            <div className="flex justify-center mt-6 space-x-2">
              {beforeAfterImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full cursor-pointer transition-colors ${
                    index === currentSlide ? 'bg-teal-600' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>

            {/* 施工事例詳細ページへのリンク */}
            <div className="text-center mt-8">
              <Link
                to="/before-after"
                className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap inline-flex items-center"
              >
                すべての施工事例を見る
                <i className="ri-arrow-right-line ml-2 text-lg"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 賃貸オーナー向けメリット */}
      <section className="py-16 bg-teal-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">賃貸オーナー様のメリット</h2>
            <p className="text-lg text-gray-600">
              クロスメイクが賃貸経営にもたらす具体的なメリット
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">空室期間の短縮</h3>
                  <p className="text-gray-600">
                    施工が早く乾燥も短時間で済むので、次の入居者への引き渡しがスムーズになります。機会損失を最小限に抑えられます。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-dollar-circle-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">原状回復コストの削減</h3>
                  <p className="text-gray-600">
                    張替えに比べて約半額のコストに抑えられるため、多数の物件を所有する方や管理会社のコスト削減に大きく貢献します。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-leaf-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">環境への配慮</h3>
                  <p className="text-gray-600">
                    廃材がほとんど出ない工法で、オーナー様のSDGsや環境負荷削減の取り組みに貢献します。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">安全・無臭</h3>
                  <p className="text-gray-600">
                    ホルムアルデヒドを含まない水性塗料で安全。施工後は無臭になり、すぐに内覧可能です。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* オーナー様の声 */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">オーナー様の声</h2>
            <p className="text-lg text-gray-600">
              実際にクロスメイクをご利用いただいたオーナー様からのお声をご紹介します
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {/* オーナー様の声 1 */}
            <div className="bg-gray-50 p-8 rounded-lg shadow-md">
              <div className="text-center mb-6">
                <img
                  src="https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/a3e92d4e57503dc06d117975575f93cb.jfif"
                  alt="田中様所有物件"
                  className="w-full h-48 object-cover rounded-lg shadow-md mb-4"
                />
                <h3 className="text-xl font-bold text-gray-800 mb-2">中田 健一様</h3>
                <p className="text-sm text-gray-600">専業大家さん</p>
              </div>

              <div className="bg-white p-6 rounded-lg">
                <div className="flex items-start mb-4">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mr-3">
                    <i className="ri-quote-text text-teal-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      「これまで退去のたびに15万円程度かかっていた原状回復費用が、クロスメイクで7万円程度に削減できました。しかも仕上げは新品同様で、入居者からの評判も上々です。空室期間も大幅に短縮され、収益性が格段に向上しました。」
                    </p>
                  </div>
                </div>
                <div className="flex items-center text-yellow-500 text-sm">
                  <i className="ri-star-fill mr-1"></i>
                  <i className="ri-star-fill mr-1"></i>
                  <i className="ri-star-fill mr-1"></i>
                  <i className="ri-star-fill mr-1"></i>
                  <i className="ri-star-fill mr-2"></i>
                  <span className="text-gray-600">満足度：★★★★★</span>
                </div>
              </div>
            </div>

            {/* オーナー様の声 2 */}
            <div className="bg-gray-50 p-8 Rounded-lg shadow-md">
              <div className="text-center mb-6">
                <img
                  src="https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/d2ce9d0836eb1ee755b9abd0dc0555f4.jfif"
                  alt="佐藤様所有物件"
                  className="w-full h-48 object-cover rounded-lg shadow-md mb-4"
                />
                <h3 className="text-xl font-bold text-gray-800 mb-2">佐藤 美香様</h3>
                <p className="text-sm text-gray-600">OL大家さん</p>
              </div>

              <div className="bg-white p-6 rounded-lg">
                <div className="flex items-start mb-4">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mr-3">
                    <i className="ri-quote-text text-teal-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      「タバコのヤニで黄ばんだ壁紙が、まるで新築のように真っ白になったのには驚きました。施工時間も短く、臭いも全くありません。管理会社からも『こんな工法があるなんて知らなかった』と感謝されています。今後は全物件でクロスメイクを採用予定です。」
                    </p>
                  </div>
                </div>
                <div className="flex items-center text-yellow-500 text-sm">
                <i className="ri-star-fill mr-1"></i>
                <i className="ri-star-fill mr-1"></i>
                <i className="ri-star-fill mr-1"></i>
                <i className="ri-star-fill mr-1"></i>
                <i className="ri-star-fill mr-2"></i>
                <span className="text-gray-600">満足度：★★★★★</span>
                </div>
              </div>
            </div>

            {/* オーナー様の声 3 */}
            <div className="bg-gray-50 p-8 rounded-lg shadow-md">
              <div className="text-center mb-6">
                <img
                  src="https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/88e2496317dc6bac3a46f6e42cc3ae44.jfif"
                  alt="山田様所有物件"
                  className="w-full h-48 object-cover rounded-lg shadow-md mb-4"
                />
                <h3 className="text-xl font-bold text-gray-800 mb-2">山田 雄二様</h3>
                <p className="text-sm text-gray-600">賃貸オフィス・貸家</p>
              </div>

              <div className="bg-white p-6 rounded-lg">
                <div className="flex items-start mb-4">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mr-3">
                    <i className="ri-quote-text text-teal-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      「たくさんの物件を保有しているため、原状回復費用は大きな負担でした。クロスメイクを導入してから年間で約120万円のコスト削減を実現。投資利回りが改善しましたよ。新品クロスでなくても入居者の満足度が高いのが嬉しいですね。」
                    </p>
                  </div>
                </div>
                <div className="flex items-center text-yellow-500 text-sm">
                <i className="ri-star-fill mr-1"></i>
                <i className="ri-star-fill mr-1"></i>
                <i className="ri-star-fill mr-1"></i>
                <i className="ri-star-fill mr-1"></i>
                <i className="ri-star-fill mr-2"></i>
                <span className="text-gray-600">満足度：★★★★★</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 料金セクション */}
      <section id="pricing" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">料金目安</h2>
            <p className="text-lg text-gray-600">
              物件の状況により変動いたします。詳細はお気軽にお問い合わせください
            </p>
          </div>

          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              {/* 料金表 */}
              <div className="bg-gray-50 p-8 rounded-lg">
                <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">標準料金</h3>
                <div className="space-y-6">
                  <div className="bg-white p-6 rounded-lg shadow-md text-center">
                    <h4 className="text-xl font-bold text-gray-800 mb-4">1R・1K</h4>
                    <div className="text-3xl font-bold text-teal-600 mb-2">¥25,000〜</div>
                    <p className="text-gray-600">約15〜20㎡</p>
                  </div>
                  <div className="bg-white p-6 rounded-lg shadow-md text-center">
                    <h4 className="text-xl font-bold text-gray-800 mb-4">1DK・1LDK</h4>
                    <div className="text-3xl font-bold text-teal-600 mb-2">¥35,000〜</div>
                    <p className="text-gray-600">約25〜35㎡</p>
                  </div>
                  <div className="bg-white p-6 rounded-lg shadow-md text-center">
                    <h4 className="text-xl font-bold text-gray-800 mb-4">2DK・2LDK</h4>
                    <div className="text-3xl font-bold text-teal-600 mb-2">¥45,000〜</div>
                    <p className="text-gray-600">約40〜50㎡</p>
                  </div>
                </div>
              </div>

              {/* 簡易見積りフォーム */}
              <div className="bg-teal-50 p-8 rounded-lg">
                <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                  簡易見積り（ワンルーム）
                </h3>
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        縦の長さ (m) <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        id="length"
                        step="0.1"
                        min="1"
                        required
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                        placeholder="例: 5.2"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        横の長さ (m) <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        id="width"
                        step="0.1"
                        min="1"
                        required
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                        placeholder="例: 3.8"
                      />
                    </div>

                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        id="ceiling"
                        className="mr-3 w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
                      />
                      <label htmlFor="ceiling" className="text-sm font-medium text-gray-700 cursor-pointer">
                        天井も施工する
                      </label>
                    </div>

                    <button
                      onClick={() => {
                        const lengthInput = document.getElementById('length') as HTMLInputElement;
                        const widthInput = document.getElementById('width') as HTMLInputElement;
                        const ceilingInput = document.getElementById('ceiling') as HTMLInputElement;
                        const resultDiv = document.getElementById('result');
                        const noteDiv = document.getElementById('note');

                        const length = parseFloat(lengthInput.value);
                        const width = parseFloat(widthInput.value);
                        const includeCeiling = ceilingInput.checked;
                        const height = 2.4;
                        const unitPrice = 650; // 円/m²

                        if (isNaN(length) || isNaN(width) || length <= 0 || width <= 0) {
                          if (resultDiv) {
                            resultDiv.textContent = '縦と横の長さを正しく入力してください。';
                            resultDiv.className =
                              'mt-4 p-3 bg-red-100 text-red-700 rounded-lg text-center';
                          }
                          if (noteDiv) {
                            noteDiv.style.display = 'none';
                          }
                          return;
                        }

                        const wallArea = (length * height * 2) + (width * height * 2);
                        let estimate = wallArea * unitPrice;

                        if (includeCeiling) {
                          const ceilingArea = length * width;
                          estimate += ceilingArea * unitPrice;
                        }

                        if (resultDiv) {
                          resultDiv.textContent = `概算見積金額：${estimate.toLocaleString()} 円`;
                          resultDiv.className =
                            'mt-4 p-4 bg-teal-100 text-teal-700 rounded-lg text-center font-semibold';
                          resultDiv.style.display = 'block';
                        }
                        if (noteDiv) {
                          noteDiv.style.display = 'block';
                        }
                      }}
                      className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                    >
                      計算する
                    </button>

                    <div id="result" className="hidden"></div>

                    <div
                      id="note"
                      className="text-xs text-gray-500 mt-3"
                      style={{ display: 'none' }}
                    >
                      ※ロフトなど天井高が高い場合は割増しとなります。<br />
                      ※汚れ・破損が多い場合は割増しとなります。
                    </div>

                    <div className="mt-4 pt-4 border-t border-gray-200">
                      <button
                        onClick={handleEstimateClick}
                        className="w-full bg-teal-600 hover:bg-teal-700 text-white py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                      >
                        作業依頼フォームへ
                      </button>
                    </div>

                  </div>
                </div>
              </div>

            </div>

            <div className="text-center">
              <p className="text-gray-600 mb-4">
                ※タバコのヤニや10年経過したクロスではダブルコーティングが必要になる場合があります<br />
                ※事前に現場写真の送付や事前点検で正確な見積もりを行います
              </p>
              <button
                onClick={handleEstimateClick}
                className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                作業依頼をする
              </button>
              
              {/* お得なクーポン案内 */}
              <div className="mt-8 pt-6 border-t border-gray-200">
                <p className="text-lg font-semibold text-gray-800 mb-4">
                  お得なクーポンはこちら
                </p>
                <a href="https://lin.ee/g0Jj95Y" target="_blank" rel="noopener noreferrer">
                  <img 
                    src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png" 
                    alt="友だち追加でお得なクーポンをゲット" 
                    height="36" 
                    className="cursor-pointer hover:opacity-80 transition-opacity mx-auto"
                  />
                </a>
                <p className="text-sm text-gray-600 mt-2">
                  LINE友だち追加でお得なクーポンをプレゼント！
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* よくある質問 */}
      <section id="faq" className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">よくある質問</h2>
          </div>

          <div className="max-w-4xl mx-auto space-y-6">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-lg font-bold text-gray-800 mb-3">
                現場に立ち会う必要はありますか？
              </h3>
              <p className="text-gray-600">
                鍵の受け渡し方法（直接・郵送・キーボックス）をご相談いただければ、オーナー様の立ち会いなしでも施工可能です。施工前後の写真でご報告いたします。
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-lg font-bold text-gray-800 mb-3">
                どの程度の汚れまで対応できますか？
              </h3>
              <p className="text-gray-600">
                一般的な汚れ（ヤニ、カビ、手垢、落書きなど）はほぼ対応可能です。尚、ワンコートで隠れない場合は追加作業が必要になります。
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-lg font-bold text-gray-800 mb-3">
                施工後の保証はありますか？
              </h3>
              <p className="text-gray-600">
                施工後1年間の品質保証をお付けしています。万が一、塗膜の剥がれや色ムラが発生した場合は無料で再施工いたします。
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-lg font-bold text-gray-800 mb-3">支払い方法は？</h3>
              <p className="text-gray-600">
                現金・銀行振込のみ。現在クレジットカード決済に対応していません。
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-lg font-bold text-gray-800 mb-3">
                施工できない壁紙はありますか？
              </h3>
              <p className="text-gray-600">
                ビニールクロス以外（布クロス、紙クロス、珪藻土など）は施工できません。また、表面にコーティングが施されているクロスも対応できない場合があります。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* メールフォーム */}
      <section id="estimate-form" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">作業依頼フォーム</h2>
            <p className="text-lg text-gray-600">
              物件の詳細をお聞かせください。
            </p>
          </div>

          <div className="max-w-2xl mx-auto">
            <form
              data-readdy-form
              id="work-request-form"
              action="https://readdy.ai/api/form/d3e8e0q63rdsndv76p2g"
              method="POST"
              className="bg-white p-8 rounded-lg shadow-md space-y-6"
              onSubmit={(e) => {
                e.preventDefault();
                const form = e.target as HTMLFormElement;
                const formData = new FormData(form);
                
                // チェックボックスの値を処理
                const damageTypes = formData.getAll('damage_type');
                if (damageTypes.length > 0) {
                  formData.delete('damage_type');
                  formData.append('damage_type', damageTypes.join(', '));
                }
                
                // URLエンコード形式に変換
                const urlEncodedData = new URLSearchParams();
                for (const [key, value] of formData.entries()) {
                  urlEncodedData.append(key, value.toString());
                }
                
                fetch('https://readdy.ai/api/form/d3e8e0q63rdsndv76p2g', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: urlEncodedData.toString()
                })
                .then(response => {
                  if (response.ok) {
                    alert('作業依頼を送信いたしました。お問い合わせありがとうございます。');
                    form.reset();
                  } else {
                    alert('送信に失敗しました。もう一度お試しください。');
                  }
                })
                .catch(error => {
                  console.error('Error:', error);
                  alert('送信に失敗しました。もう一度お試しください。');
                });
              }}
            >
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    お名前 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    placeholder="山田太郎"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    電話番号 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    placeholder="090-1234-5678"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  メールアドレス <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  placeholder="example@email.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  物件所在地 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="property_address"
                  required
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  placeholder="埼玉県さいたま市浦和区○○町1-2-3"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    物件タイプ <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="property_type"
                    required
                    className="w-full p-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  >
                    <option value="">選択してください</option>
                    <option value="1R">1R</option>
                    <option value="1K">1K</option>
                    <option value="1DK">1DK</option>
                    <option value="1LDK">1LDK</option>
                    <option value="2DK">2DK</option>
                    <option value="2LDK">2LDK</option>
                    <option value="3DK">3DK</option>
                    <option value="3LDK">3LDK</option>
                    <option value="その他">その他</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    面積（㎡）
                  </label>
                  <input
                    type="number"
                    name="area"
                    step="0.1"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    placeholder="例：25.5"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    電気・水道 <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="utilities"
                    required
                    className="w-full p-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  >
                    <option value="">選択してください</option>
                    <option value="あり">あり</option>
                    <option value="なし">なし</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    駐車スペース <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="parking"
                    required
                    className="w-full p-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  >
                    <option value="">選択してください</option>
                    <option value="あり">あり</option>
                    <option value="なし">なし</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  汚れの状況
                </label>
                <div className="space-y-2">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="damage_type"
                      value="ヤニ汚れ"
                      className="mr-2"
                    />
                    <span className="text-gray-700">ヤニ汚れ</span>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="damage_type"
                      value="カビ"
                      className="mr-2"
                    />
                    <span className="text-gray-700">カビ</span>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="damage_type"
                      value="手垢・汚れ"
                      className="mr-2"
                    />
                    <span className="text-gray-700">手垢・汚れ</span>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="damage_type"
                      value="落書き"
                      className="mr-2"
                    />
                    <span className="text-gray-700">落書き</span>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="damage_type"
                      value="その他"
                      className="mr-2"
                    />
                    <span className="text-gray-700">その他</span>
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  希望施工日
                </label>
                <input
                  type="date"
                  name="preferred_date"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  その他ご要望・質問
                </label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  placeholder="その他ご不明な点やご要望がございましたらお聞かせください"
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">※500文字以内でご入力ください</p>
              </div>

              <button
                type="submit"
                className="w-full bg-orange-500 hover:bg-orange-600 text-white py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                作業依頼を送信する
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* 会社概要 */}
      <section id="company" className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">会社概要</h2>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4">会社情報</h3>
                  <div className="space-y-3">
                    <div className="flex">
                      <span className="w-20 text-gray-600">社名：</span>
                      <span className="text-gray-800">39raリフォーム有限会社　サクラリフォーム</span>
                    </div>
                    <div className="flex">
                      <span className="w-20 text-gray-600">代表：</span>
                      <span className="text-gray-800">瀬下尊由希</span>
                    </div>
                    <div className="flex">
                      <span className="w-20 text-gray-600">住所：</span>
                      <span className="text-gray-800">埼玉県さいたま市浦和区3-13-15</span>
                    </div>
                    <div className="flex">
                      <span className="w-20 text-gray-600">電話：</span>
                      <span className="text-gray-800">048-614-1544</span>
                    </div>
                    <div className="flex">
                      <span className="w-20 text-gray-600">主な事業：</span>
                      <span className="text-gray-800">外壁塗装、屋根塗装、防水塗装、クロスメイクによる壁紙再生</span>
                    </div>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4">サービス一覧</h3>
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      クロスメイク（壁紙再生）
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      外壁塗装
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      屋根塗装
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      防水工事
                    </li>
                  </ul>

                  <div className="mt-6">
                    <h4 className="text-lg font-semibold text-gray-800 mb-3">対応エリア</h4>
                    <p className="text-gray-600">
                      埼玉県全域、東京都内の一部地域<br />
                      その他の地域もご相談ください
                    </p>
                  </div>

                  <div className="mt-6">
                    <h4 className="text-lg font-semibold text-gray-800 mb-3">営業時間</h4>
                    <p className="text-gray-600">
                      平日・土曜日：9:00～18:00<br />
                      日曜日・祝日：定休日
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 会社所在地マップ */}
            <div className="mt-8 bg-white p-8 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-gray-800 mb-6 text-center">
                会社所在地
              </h3>
              <div className="space-y-4">
                <div className="text-center">
                  <div className="flex items-center justify-center mb-2">
                    <i className="ri-map-pin-line text-teal-600 text-xl mr-2"></i>
                    <span className="text-lg font-semibold text-gray-800">
                      39raリフォーム有限会社　サクラリフォーム
                    </span>
                  </div>
                  <p className="text-gray-600">
                    埼玉県さいたま市浦和区3-13-15
                  </p>
                </div>

                <div className="w-full h-96 rounded-lg overflow-hidden border">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.123456789!2d139.6503!3d35.8617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzXCsDUxJzQyLjEiTiAxMznCsDM5JzAxLjEiRQ!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="39raリフォーム有限会社 サクラリフォーム所在地"
                  ></iframe>
                </div>

                <div className="text-center text-sm text-gray-500">
                  <p>
                    JR京浜東北線・宇都宮線・高崎線「浦和駅」よりアクセス良好
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div
                className="text-2xl font-bold text-teal-400 mb-4"
                style={{ fontFamily: 'Pacifico, serif' }}
              >
                壁紙革命浦和
              </div>
              <p className="text-gray-300 mb-4">
                39raリフォーム有限会社　サクラリフォーム<br />
                代表：瀬下尊由希<br />
                TEL: 048-614-1544
              </p>
              <p className="text-gray-400 text-sm">
                外壁塗装、屋根塗装、防水塗装、<br />
                クロスメイクによる壁紙再生
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">サービス一覧</h4>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <a
                    href="#service"
                    className="hover:text-teal-400 cursor-pointer transition-colors"
                  >
                    クロスメイク
                  </a>
                </li>
                <li>
                  <a
                    href="#case-studies"
                    className="hover:text-teal-400 cursor-pointer transition-colors"
                  >
                    施工事例
                  </a>
                </li>
                <li>
                  <a
                    href="#pricing"
                    className="hover:text-teal-400 cursor-pointer transition-colors"
                  >
                    料金案内
                  </a>
                </li>
                <li>
                  <a
                    href="#faq"
                    className="hover:text-teal-400 cursor-pointer transition-colors"
                  >
                    よくある質問
                  </a>
                </li>
                <li>
                  <a
                    href="#estimate-form"
                    className="hover:text-teal-400 cursor-pointer transition-colors"
                  >
                    見積り依頼
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
              <div className="space-y-2 text-gray-300">
                <div className="flex items-center">
                  <i className="ri-phone-line mr-2 text-teal-400"></i>
                  <span>048-614-1544</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-time-line mr-2 text-teal-400"></i>
                  <span>平日・土曜 9:00-18:00</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-map-pin-line mr-2 text-teal-400"></i>
                  <span>埼玉県さいたま市浦和区</span>
                </div>
              </div>

              <div className="mt-4">
                <a
                  href="http://www.39ra.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer"
                >
                  さいたま市の外壁塗装専門店　39raリフォーム有限会社
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>
              © 2024 39raリフォーム有限会社　サクラリフォーム. All rights reserved.
              <span className="mx-2">|</span>
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-teal-400 transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
